import { Input } from "../ui/input";

export const emptyPax = (seats, prev = {}, first) => Object.fromEntries(seats.map((s, i) => [s, prev[s] ?? (i === 0 && first ? first : { name: "", dni: "" })]));
export const paxValid = (seats, pax) => seats.every((s) => (pax[s]?.name ?? "").trim().length >= 2 && /^\d{6,10}$/.test(pax[s]?.dni ?? ""));
export const paxList = (seats, pax) => seats.map((s) => ({ seat: s, name: pax[s].name.trim(), dni: pax[s].dni }));

export const PaxFields = ({ seats, pax, onChange, dark = false, labelOf, testPrefix = "pax" }) => (
  <div data-testid={`${testPrefix}-fields`} className="space-y-2">
    {seats.map((s) => {
      const set = (k) => (e) => onChange({ ...pax, [s]: { ...pax[s], [k]: k === "dni" ? e.target.value.replace(/\D/g, "") : e.target.value } });
      return (
        <div key={s} className="grid grid-cols-[1fr_7rem] items-center gap-2 sm:grid-cols-[5rem_1fr_8rem]">
          <span className={`col-span-2 font-mono text-xs sm:col-span-1 ${dark ? "text-[var(--lime)]" : "text-[var(--muted-ink)]"}`}>{labelOf ? labelOf(s) : `Butaca ${s}`}</span>
          <Input data-testid={`${testPrefix}-name-${s}`} placeholder="Nombre y apellido" value={pax[s]?.name ?? ""} onChange={set("name")} className={`h-10 min-w-0 ${dark ? "text-[var(--ink)]" : "rounded-xl"}`} />
          <Input data-testid={`${testPrefix}-dni-${s}`} placeholder="DNI" inputMode="numeric" maxLength={10} value={pax[s]?.dni ?? ""} onChange={set("dni")} className={`h-10 min-w-0 ${dark ? "text-[var(--ink)]" : "rounded-xl"}`} />
        </div>
      );
    })}
  </div>
);
